import styled from 'styled-components';

export const DoneWrapper = styled.div`
  font-size: 19px;
  font-weight: 800;
  text-align: left;

  @media (max-width: 991px) {
    margin-top: 24px;
    text-align: center;
  }
`;

export const ImageContainer = styled.div`
  h6 {
    text-align: center;
    margin-bottom: 16px;
    font-size: 14px;
  }
`;

export const ResponsiveImage = styled.img`
  max-width: 100%;
  height: auto;
`;

export const ZoomImageContainer = styled.div`
  position: relative;
  img {
    &:hover {
      cursor: zoom-in;
    }
  }
`;

export const ZoomIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  ${'' /* right: 20%; */}
  width: 20px;
  height: auto;
  z-index: 0;
`;
